// Polyfill Buffer for browser environment
import { Buffer } from 'buffer'
window.Buffer = Buffer
globalThis.Buffer = Buffer

import Vue from 'vue'
import App from './App.vue'
import VeeValidate from 'vee-validate'
import SmartTable from 'vuejs-smart-table/dist/smart-table.umd.js'
import draggable from 'vuedraggable'
import VJsf from '@koumoul/vjsf'
import '@koumoul/vjsf/dist/main.css'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import 'prismjs' // https://vuejsexamples.com/a-dead-simple-code-editor-with-syntax-highlighting-and-line-numbers/
import 'prismjs/themes/prism-tomorrow.css'
import 'vue-prism-editor/dist/VuePrismEditor.css'

import router from './router'
import Trim from './directives/InputTrimDirective'
import NotifyOnOpenDirective from './directives/NotifyOnOpenDirective'
import HttpRequestProgressInterceptor from './interceptor/httpRequestProgressInterceptor'
import ApiErrorInterceptor from './interceptor/apiErrorInterceptor'
import vuetify from './plugins/vuetify'
import NotifyPlugin from './plugins/notify'

import FileNameCheck from './validations/fileNameCheck'
import { GameApiPlugin } from './plugins/game-api';

import { msalPlugin } from "./plugins/msal";
import { sentryPlugin } from './plugins/sentry';
import config from './config/'

console.log(`Using config ${process.env.NODE_ENV}`, config);
// extending validator with custom validation, checking filename
VeeValidate.Validator.extend('fileNameCheck', FileNameCheck)

Vue.use(sentryPlugin, { dsn: config.sentryDsn, environment: config.sentryEnvironment });
Vue.use(msalPlugin, config.msalConfig);
Vue.use(VeeValidate)
Vue.use(SmartTable)
Vue.use(VueSweetalert2)
Vue.use(vuetify)
Vue.use(GameApiPlugin)
Vue.use(NotifyPlugin)

// Enforce manual close for all SweetAlert2 popups (no auto-dismiss timers) and queue modals
const __originalSwal = Vue.prototype.$swal
if (__originalSwal && __originalSwal.fire) {
  const __originalFire = __originalSwal.fire.bind(__originalSwal)
  const __swalQueue = []
  let __swalActive = false

  function sanitizeOptionsFromArgs (args) {
    let options
    if (args.length === 1 && args[0] && typeof args[0] === 'object') {
      options = { ...args[0] }
    } else if (args.length === 2 || args.length === 3) {
      const [title, text, icon] = args
      options = { title, text, icon }
    } else {
      options = {}
    }
    // Remove timers to prevent auto-dismiss
    if ('timer' in options) {
      delete options.timer
    }
    if ('timerProgressBar' in options) {
      delete options.timerProgressBar
    }
    // Always show confirm button
    if (options.showConfirmButton === false) {
      options.showConfirmButton = true
    }
    // Require explicit user action by default (unless explicitly overridden)
    if (options.allowOutsideClick === undefined) {
      options.allowOutsideClick = false
    }
    if (options.allowEscapeKey === undefined) {
      options.allowEscapeKey = false
    }
    return options
  }

  function processNext () {
    if (__swalActive) return
    const job = __swalQueue.shift()
    if (!job) return
    __swalActive = true
    __originalFire(job.options)
      .then(result => job.resolve(result))
      .catch(err => job.reject(err))
      .finally(() => {
        __swalActive = false
        processNext()
      })
  }

  __originalSwal.fire = (...args) => {
    const options = sanitizeOptionsFromArgs(args)
    // Auto-notify via snackbar for success/info modals
    try {
      const icon = options.icon
      if (icon === 'success' || icon === 'info') {
        // Prefer main title; fallback to text, then html (stripped)
        let message = options.title || options.text
        if (!message && options.html) {
          const tmp = document.createElement('div')
          tmp.innerHTML = options.html
          message = tmp.textContent || tmp.innerText || ''
        }
        if (message && Vue.prototype.$notify) {
          Vue.prototype.$notify({ text: message, type: icon })
        }
      }
    } catch (e) {
      // noop
    }
    return new Promise((resolve, reject) => {
      __swalQueue.push({ options, resolve, reject })
      processNext()
    })
  }
}

Vue.component('draggable', draggable)
Vue.component('VJsf', VJsf)
Vue.directive('input-trim', Trim)
Vue.directive('notify-on-open', NotifyOnOpenDirective)

HttpRequestProgressInterceptor.initialize()
ApiErrorInterceptor.initialize()

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify: vuetify,
  components: { App },
  data: {
    apiError: '',
    httpRequestInProgressCount: 0
  },
  methods: {
    onApiErrorClosed: function () {
      this.apiError = ''
    }
  },
  template: '<App :api-error="apiError" :http-request-in-progress-count="httpRequestInProgressCount" @apiErrorClosed="onApiErrorClosed"/>',
})
